import { render, staticRenderFns } from "./EditCompanyLogo.vue?vue&type=template&id=3af0c1f9&scoped=true"
import script from "./EditCompanyLogo.vue?vue&type=script&lang=js"
export * from "./EditCompanyLogo.vue?vue&type=script&lang=js"
import style0 from "./EditCompanyLogo.vue?vue&type=style&index=0&id=3af0c1f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af0c1f9",
  null
  
)

export default component.exports